import * as Primitive from '@radix-ui/react-tooltip'
import type { ComponentProps } from 'react'
import { cn } from '../lib/cn'
export function Tooltip({ children, ...props }: ComponentProps<typeof Primitive.Root>) {
  return (
    <Primitive.Provider delayDuration={350}>
      <Primitive.Root {...props}>{children}</Primitive.Root>
    </Primitive.Provider>
  )
}
export function TooltipTrigger(props: ComponentProps<typeof Primitive.Trigger>) {
  return <Primitive.Trigger {...props} />
}
export function TooltipContent({
  className,
  sideOffset = 6,
  ...props
}: ComponentProps<typeof Primitive.Content>) {
  return (
    <Primitive.Portal>
      <Primitive.Content
        {...props}
        sideOffset={sideOffset}
        className={cn(
          'z-[70] max-w-64 rounded-lg bg-foreground px-3 py-2 text-xs leading-5 text-background shadow-lg',
          className,
        )}
      />
    </Primitive.Portal>
  )
}
